import React from 'react';
import { useFormContext } from 'react-hook-form';
import I18n from '@/modules/i18n';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';
import cn from '@/utils/cn';

const SelectedStudentsNotice = () => {
  const { watch } = useFormContext();
  const allFormValues = watch();
  const totalStudentsSelected = Object.values(allFormValues).flat().length;

  if (totalStudentsSelected === 0) return null;

  return (
    <div
      className={cn(
        'tw-rounded tw-flex tw-items-center tw-gap-2 tw-py-2 tw-px-4 tw-border tw-border-solid tw-border-teal-blue',
        'tw-bg-teal-blue/5 tw-text-teal-blue',
      )}
    >
      <Icon icon="EditUser" size={21} />
      <Text size="sm" weight="bold">
        {I18n.t('notify_students_selected', { count: totalStudentsSelected })}
      </Text>
    </div>
  );
};

export default SelectedStudentsNotice;
